import { render, staticRenderFns } from "./SubContentForm.vue?vue&type=template&id=fab84cc6&"
import script from "./SubContentForm.vue?vue&type=script&lang=js&"
export * from "./SubContentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports